import { IPrivacy } from '@/models/interfaces';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import { axiosGet } from 'utilities/axiosManagerFunctions';

interface IPrivacyPolicyStatusResponse {
  privacyPolicyStatus: 'NotConsented' | 'Accepted' | 'Declined' | 'Expired';
}

export const axiosGetPrivacyPolicyStatus = async (
  token: string
): Promise<IPrivacyPolicyStatusResponse> => {
  try {
    const response = await axiosGet<IPrivacyPolicyStatusResponse>(
      `privacy/user-consent`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (err: any) {
    const errorMessage = err.message || err.toString();
    throw new Error(`API Error: "${errorMessage}"`);
  }
};

export const getPrivacyUserConsent = async (
  token: string
): Promise<any> => {
  try {
    const response = await axiosGet<IPrivacy.IPrivacyPolicyConsentResponse>(
      `iam/v2/privacy/user-consent`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  } catch (err: any) {
    const errorMessage = err.message || err.toString();
    throw new Error(`API Error: "${errorMessage}"`);
  }
};



